<template>
  <div>
    <!-- 图片 -->
    <el-upload :action="url" list-type="picture-card" :headers="headers" :on-success="handleSuccess" name="file" multiple :limit="limit" v-if="type == 'img'">
      <i slot="default" class="el-icon-plus"></i>
      <div slot="file" slot-scope="{file}">
        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
            <i class="el-icon-zoom-in"></i>
          </span>
          <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>

    <!-- 文件 -->
    <el-upload class="upload-demo" v-else :action="url" name="file" :on-preview="handlePreview" :on-remove="handleRemove"
      :before-remove="beforeRemove" :headers="headers" :on-success="handleSuccess" multiple :limit="limit" :on-exceed="handleExceed" :file-list="fileList">
      <div class="flex-row">
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">{{tips}}</div>
      </div>
    </el-upload>


    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
import { deepClone } from '@/utils/utils'
export default {
  props: {
    type: {
      type: String,
      default() {
        return 'img'
      }
    },
    url: {
      type: String,
      default() {
        return this.GetAiUrl() + '/upload'
      }
    },
    limit: {
      type: Number,
      default() {
        return 1
      }
    },
    tips: {
      type: String,
      default() {
        return '文件大小不超过2M'
      }
    },
    datas: {
      type: String,
      default() {
        return ''
      }
    },
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      fileList: [],
      headers: { 
        'tenant-id': localStorage.getItem("wwmxt_Rootid"),
        'token': localStorage.getItem("ai_Token") 
      }
    };
  },
  watch:{
    list: {
      handler(nval){
        this.fileList = deepClone(nval);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handlePreview(file) {
      if(!file.url) return;
      window.open(file.url)
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件`);
    },
    handleSuccess(response, file, fileList){
      if(file.status === 'success'){
        let str = fileList.map(item=>{
          return item.response.data;
        })
        this.$emit('update:datas', str.join(','));
      }
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    }
  }
}
</script>
<style scoped lang="scss">
.flex-row{
  gap: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.el-upload__tip{
  margin-top: 0;
}
</style>